// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__riEoj","importantInfo":"styles_importantInfo__37iKF"};